import e from "@dialpad/dialtone-tokens/layered/themes/tokens-106-colors.css?inline";
//#region themes/106.js
var t = { brand: {
	css: e,
	name: "106"
} };
//#endregion
export { t as default };
